//import * as Helper from "../../../../utils/Helper";
import ApiService from "../../../../ApiService";
import Constants from "../../../../../config/Constants";

const EditService = {
    loadScreenView: (id, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/letter/edit/loadscreenview", { id }, successCallback, failureCallback);
    },
    saveLetters: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/letter/edit/save", vo, successCallback, failureCallback);
    },
    batchAddLetters: (vo, successCallback, failureCallback) => {
        ApiService.post("/web/admin/dictionary/letter/edit/batchadd", vo, successCallback, failureCallback);
    },
    uploadImage: (file, successCallback, failureCallback) => {
        let formData = new FormData();
        formData.append("fileData", file);
        formData.append("table", "Letters");
        formData.append("field", "Images");
        formData.append("uploadPath", Constants.FILE_STORAGE.TEMP_PATH + "letter/images/");
        ApiService.postFileToServer("/common/file/upload", formData, successCallback, failureCallback);
    },
};

export default EditService;
